import React from 'react';
import { find } from 'lodash';

// React view component to render
import { addCreditOverlay as AddCreditOverlayView } from 'ui/views/widgets/addCreditOverlay';
import { AddCreditService } from 'services/addCredit';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { popover } from 'modules/popover';
import { getLabel } from 'utils/getLabel';
import * as successOverlay from 'utils/successOverlay';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AddEditAddressForm } from 'ui/containers/AddEditAddressForm';
 *
 * // render
 * <AddEditAddressForm propName='propValue'/>
 */
export class AddCreditOverlay extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: false,
            creditData: {},
            mode: 'form',
            selected: {}
        };

        this._bind();
        this.addCreditService = new AddCreditService();

        // create service instance
        // this.memberAddEditAddressService = new MemberAddEditAddressService();
    }

    _bind() {
        this.handleFormSubmit = this.handleFormSubmit.bind( this );
    }

    /**
     * action executed, wehen user makes an address selection
     */
    handleAddressSelection( { selectionType, address } ) {
        log.debug( 'AddEditAddressForm.handleAddressSelection()' );

        this.setState( {
            selected: {
                selectionType,
                address
            }
        } );
    }

    /**
     * action executed when user clicks on form submit
     */
    async handleFormSubmit( formData ) {
        log.debug( 'AddEditAddressForm.handleFormSubmit()' );

        // close opened popovers
        popover.close();

        // cancel ongoing request
        // this.memberAddEditAddressService.cancel();

        // show page preloader
        pageLevelPreloader.show();
        const url = find( this.props.actions, { name: 'submit' } )[ 'url' ];
        const successAction = find( this.props.actions, { name: 'submit' } )[ 'onSuccess' ];

         // set the address default
        const data = await this.addCreditService.submitAddCredit( {
            url,
            data: {context: { ...this.props.context }, data: formData}
        } );
        const { status } = data?.body;
            
        pageLevelPreloader.hide();
        
        if ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( {
                message: getLabel( successAction ),
            } );
        } else {
            errorOverlay.open();
        }
        
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AddCreditOverlayView
                { ...this.state }
                { ...this.props }
                onFormSubmit = { this.handleFormSubmit }
            />
        );
    }
}

// set display name
AddCreditOverlay.displayName = 'AddCreditOverlay';

// set default props
AddCreditOverlay.defaultProps = {};

// prop types
AddCreditOverlay.propTypes = {};
